<template>
  <div class="full-calendar-container" :style="[typeCalendar === 'caregiverLeave' ? {'width': 'auto'} : {'width': '750px'}]">
    <full-calendar :config="configCurrent" ref="currentMonthCalendar" :events="eventsCalendar" selectable :style="[typeCalendar === 'caregiverLeave' ? {'width': '440px'} : '']" />
    <full-calendar :config="configNext" ref="nextMonthCalendar" :events="eventsCalendar" selectable :style="[typeCalendar === 'caregiverLeave' ? {'margin-left': '60px', 'width': '440px'} : {'margin-left': '16px'}]"/>

    <!-- remove Selected Date Dialog -->
    <el-dialog :visible.sync="control.showRemoveSelectedDateDialog" :closeOnClickModal="false" style="margin-top: 19vh; z-index: 3000;" width="30%" :appendToBody="true">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="header-18" style="margin-left: 17px;">คุณต้องการลบวันที่เลือก?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleEventClick(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleEventClick(true)">ลบ</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .full-calendar-container {
    height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .header-18 {
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;
      color: #434B61;
    }
</style>

<style lang="scss">
  ._cs-pt {
    cursor: pointer;
  }

  ._cs-nal {
    cursor: not-allowed;
  }

  .calendar-container {
    .fc-head-container.fc-widget-header {
      padding: 0px;
      border: 0;
    }

    .el-icon-arrow-left, .el-icon-arrow-right {
      border: none;
      font-size: xx-large;
      font-weight: 900;
    }

    .el-button.el-button--default,
    .el-button.el-button--default:hover {
      border: none;
      background: transparent;
    }
  }

  .calendar-container {
    .fc-unthemed .fc-disabled-day {
      background-color: #F1F3F6 !important;
      opacity: 1;
    }

    .el-button {
      border: 0;
    }

    .fc-widget-content {
      padding: 0;
    }

    .fc .fc-row .fc-content-skeleton table, .fc .fc-row .fc-content-skeleton td, .fc .fc-row .fc-helper-skeleton td {
      border-color: #ddd !important;
    }

    .fc-highlight {
      background-color: inherit !important;
    }

    .fc-bg {
      background-color: #FFFFFF;
    }

    .fc-past {
      background-color: #F1F3F6 !important;
      color: #D5D6DB !important;
    }

    .fc-day .fc-widget-content .fc-past {
      background-color: #F1F3F6 !important;
    }

    .fc-today {
      background: tranparent !important;
      color: #606266 !important;
    }

    .fc-day:hover.fc-widget-content:not(.fc-past):not(.fc-disabled-day) {
      opacity: 1;
      background: #EDF3FF !important;
      cursor: pointer;
    }

    .fc-highlight-skeleton {
      display: none;
    }
  }
</style>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { GenericAPIHandler } from './GenericAPIHandler'

const moment = extendMoment(Moment)

export default {
  name: 'DayPickerCalendar',
  mixins: [GenericAPIHandler],
  props: {
    value: {
      type: Array,
      required: true,
    },
    allowDates: {
      type: Array,
    },
    isAllowAddEvent: {
      type: Boolean,
      default: true,
    },
    isCaregiverLeave: {
      type: String,
      default: 'false',
    },
    maxDate: {
      type: Number,
      default: 0,
    },
    pck: {
      type: String,
      required: false,
    },
    typeCalendar: {
      type: String,
      required: false,
    },
    daysOff: {
      type: Array,
      required: false,
    },
    initDate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    eventsCalendar (val) {
      const dates = this.generatedDatesArray(val)
      this.$emit('input', dates)
    },
    value (val) {
      this.backgroundColorHandler()
    },
    pck (val) {
      this.backgroundColorHandler()
    },
  },
  data () {
    return {
      dates: [],
      eventsCalendar: [],
      configCurrent: {
        defaultView: 'month',
        firstDay: 1,
        locale: 'th',
        selectable: true,
        editable: false,
        height: 460,
        fixedWeekCount: false,
        showNonCurrentDates: false,
        header: {
          left: '',
          center: 'title',
          right: '',
        },
        displayEventTime: false,
        dayNamesShort: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        eventColor: '#676E81',
        defaultDate: moment(),
        select: this.onSelectDate,
        eventClick: this.eventClick('eventsCalendar', this),
      },
      configNext: {
        defaultView: 'month',
        firstDay: 1,
        locale: 'th',
        selectable: true,
        editable: false,
        height: 460,
        fixedWeekCount: false,
        showNonCurrentDates: false,
        header: {
          left: '',
          center: 'title',
          right: '',
        },
        displayEventTime: false,
        dayNamesShort: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        eventColor: '#676E81',
        defaultDate: moment().add(1, 'months'),
        select: this.onSelectDate,
        eventClick: this.eventClick('eventsCalendar', this),
      },
      control: {
        showRemoveSelectedDateDialog: false,
      },
      calEvent: null,
      calendarEvents: null,
      dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    }
  },
  computed: {
    tranformDaysOff () {
      const dof = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
      let formatDaysoff = []
      for (let i = 0; i < this.daysOff.length; i++) {
        let d = dof[this.dayOfWeek.indexOf(this.daysOff[i])]
        formatDaysoff.push(d)
      }
      return formatDaysoff
    },
  },
  methods: {
    foceUpdateDataContinuous (dates) {
      let start = dates[0]
      let end = 0
      this.eventsCalendar = []

      for (let i = 0; i < dates.length; i++) {
        end = dates[i]
        if (this.daysOff.indexOf(this.dayOfWeek[Moment(end).add(1, 'days').day()]) >= 0 || i === dates.length - 1) {
          this.eventsCalendar.push({
            title: '',
            start: start,
            end: Moment(Moment(end).startOf('date').add(1, 'days'), 'YYYY-MM-DD'),
          })
          if (i !== dates.length - 1) start = dates[i + 1]
        }
      }
    },
    foceUpdateData (dates) {
      this.$nextTick(() => {
        if (this.typeCalendar === 'createReservation' || this.typeCalendar === 'editReservation') {
          if (dates.length === 0) {
            this.eventsCalendar = []
            return
          }
        }
        return dates.map(date => {
          let endDate = new Date(date)
          endDate.setDate(endDate.getDate() + 1)
          let n = Moment(Moment(), 'YYYY-MM-DD').startOf('date')
          let d = Moment(date, 'YYYY-MM-DD').startOf('date')
          let isPast = d.diff(n, 'days') < 0
          let color = '#676E81'
          let className = '_cs-pt'
          if (isPast) {
            color = '#D5D6DB'
            className = '_cs-nal'
          }
          this.eventsCalendar.push({
            title: '',
            start: moment(new Date(date)).utc(),
            end: moment(endDate).utc(),
            color: color,
            className: className,
          })
        })
      })
    },
    async onSelectDate (startDate, endDate) {
      try {
        this.$message.close()
        let currentDay = moment().range(startDate, endDate).diff('days')
        let dateArray = this.generatedDatesArray([{ start: startDate, end: endDate }]) // selected Date
        let dateNotAllow = [] // can't select these Date
        let raw
        if (this.pck !== 'daily') {
          raw = await this.$api.Reservation.calculateDates(this.pck, startDate, this.daysOff)
          dateArray = [...raw.dates]
        }

        // dateNotAllow for Daily Package (create reservation)
        dateNotAllow = dateArray.filter((item) => {
          const dateString = item.split('T')[0]
          let now = Moment(Moment(), 'YYYY-MM-DD').startOf('date')
          let date = Moment(dateString, 'YYYY-MM-DD').startOf('date')
          return date.diff(now, 'days') < 0
        })

        // have allowDates
        if (this.isAllowAddEvent === false) {
          dateNotAllow = dateArray.filter((item) => {
            const dateString = item.split('T')[0]
            if (this.allowDates) {
              return this.allowDates.indexOf(dateString) < 0
            } else {
              return false
            }
          })
          dateArray = [...dateNotAllow]
        }

        // isPast or isSun(when package is MONTHYL)
        if (this.pck === 'monthly') {
          dateNotAllow = dateArray.filter((item) => {
            const dateString = item.split('T')[0]
            let now = Moment(Moment(), 'YYYY-MM-DD').startOf('date')
            let date = Moment(dateString, 'YYYY-MM-DD').startOf('date')
            let isPast = date.diff(now, 'days') < 0
            let isDaysOff = this.daysOff.indexOf(this.dayOfWeek[Moment(dateString, 'YYYY-MM-DD').startOf('date').day()]) >= 0
            return isPast || isDaysOff
          })
        }

        // add alert to Date that can't select
        if (dateNotAllow.length > 0 || this.typeCalendar === 'caregiverLeave' || this.typeCalendar === 'cancelNowTotal' || this.typeCalendar === 'cancelNowPartial') {
          let dates = dateNotAllow.map((date) => { return `${new Date(date).getDate()}` }).join(', ')
          this.$message({ message: `ไม่สามารถเพิ่มวัน ${dates} ได้`, type: 'error' })
          return
        }

        // check seleced Date is DUPLICATE with Date that has been selected before
        const isDuplicateDate = this.eventsCalendar.filter((event) => {
          return (
            moment(startDate).isBetween(event.start, event.end) ||
            moment(endDate).isBetween(event.start, event.end) ||
            moment(event.start).isBetween(startDate, endDate) ||
            moment(event.end).isBetween(startDate, endDate) ||
            moment(startDate).isSame(event.start) ||
            moment(endDate).isSame(event.end)
          )
        })

        if (isDuplicateDate.length !== 0) {
          // have DUPLICATE
          this.$message({ message: 'วันซ้ำ', type: 'error', duration: 1200 })
        } else if (
          (this.pck === 'daily' ||
          (this.pck === 'monthly' || this.pck === 'monthlyWithAddon') && this.typeCalendar === 'editReservation') &&
          ((this.value.length + currentDay > this.maxDate) && this.maxDate !== -1)
        ) {
          // select Date more than No. of Pcackage
          this.$alert(`คุณเลือกวันเกินที่แพคเกจกำหนด (${this.maxDate + ' วัน'}) กรุณาเลือกวันใหม่`, '', {
            confirmButtonText: 'โอเค',
            type: 'warning',
          })
        } else if (
          (this.pck === 'monthly' || this.pck === 'monthlyWithAddon') && this.typeCalendar === 'createReservation' &&
          this.value.length > 0 &&
          currentDay > 0
        ) {
          // select Date more than No. of Pcackage
          this.$alert(`คุณเลือกวันเกินที่แพคเกจกำหนด (1 เดือน) กรุณาเลือกวันใหม่`, '', {
            confirmButtonText: 'โอเค',
            type: 'warning',
          })
        } else {
          // create, edit reservation
          if (this.typeCalendar === 'createReservation' || this.typeCalendar === 'editReservation') {
            switch (this.typeCalendar === 'editReservation' ? 'daily' : this.pck) {
              case 'daily':
                this.eventsCalendar.push({
                  title: '',
                  start: startDate,
                  end: endDate,
                })
                break
              case 'monthly':
                let start = raw.dates[0]
                let end = 0

                // split selected bar on calendar
                for (let i = 0; i < raw.dates.length; i++) {
                  end = raw.dates[i]
                  if (this.daysOff.indexOf(this.dayOfWeek[Moment(end).add(1, 'days').day()]) >= 0 || i === raw.dates.length - 1) {
                    this.eventsCalendar.push({
                      title: '',
                      start: start,
                      end: Moment(Moment(end).startOf('date').add(1, 'days'), 'YYYY-MM-DD'),
                    })
                    if (i !== raw.dates.length - 1) start = raw.dates[i + 1]
                  }
                }
                break
              case 'monthlyWithAddon':
                this.eventsCalendar.push({
                  title: '',
                  start: raw.dates[0],
                  end: Moment(Moment(raw.dates[raw.dates.length - 1]).startOf('date').add(1, 'days'), 'YYYY-MM-DD'),
                })
                break
            }
          } else if (this.typeCalendar === 'createBooking' || this.typeCalendar === 'editBooking' || this.typeCalendar === 'cancelNowTotal' || this.typeCalendar === 'cancelNowPartial') {
            this.eventsCalendar.push({
              title: '',
              start: startDate,
              end: endDate,
            })
          }
        }
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    setCalendar (numDate) {
      let selecter = `.fc-day.fc-widget-content:not(.fc-past):not(.fc-disabled-day)${this.pck === 'monthly' ? ':not(.fc-sun)' : ''}`
      let hoverDate = document.querySelectorAll(selecter)
      let pck = this.pck
      let calculateDates = this.calculateDates

      hoverDate.forEach(
        (day) => {
          day.onmouseenter = null
          day.onmouseenter = function () {
            if (pck !== 'daily') {
              calculateDates(pck, Moment(day.getAttribute('data-date')).format('YYYY-MM-DD'))
            }
          }
          day.onmouseleave = null
          let self = this
          day.onmouseleave = function () {
            for (let i = 0; i < 365; i++) {
              let d = Moment(day.getAttribute('data-date')).add(i, 'days').format('YYYY-MM-DD')
              let dom = document.querySelector(`.calendar-container:not([style*="display: none"]) .fc-day.fc-widget-content:not(.fc-past):not(.fc-disabled-day)[data-date="${d}"]`)
              if (dom) {
                dom.style.cssText = 'opacity: 1; background-color: #FFFFFF;'
              }
            }
            self.setBackgroundWithPck()
          }
        }
      )
    },
    async calculateDates (pck, startDate) {
      let raw = await this.$api.Reservation.calculateDates(pck, startDate)
      for (let i = 0; i < raw.dates.length; i++) {
        let dom = document.querySelector(`.calendar-container:not([style*="display: none"]) .fc-day.fc-widget-content:not(.fc-past):not(.fc-disabled-day)[data-date="${raw.dates[i]}"]`)
        if (dom !== null) {
          dom.style.cssText = 'opacity: 1; background-color: #FFFF00 !important;'
        }
      }
    },
    previousMonth () {
      this.$refs.currentMonthCalendar.fireMethod('prev')
      this.$refs.nextMonthCalendar.fireMethod('prev')
      this.backgroundColorHandler()
    },
    nextMonth () {
      this.$refs.currentMonthCalendar.fireMethod('next')
      this.$refs.nextMonthCalendar.fireMethod('next')
      this.backgroundColorHandler()
    },
    handleEventClick (status) {
      if (status) {
        if (this.typeCalendar !== 'cancelNowTotal') {
          this[this.calendarEvents] = this[this.calendarEvents].filter((event) => {
            let createReservationCase = this.typeCalendar === 'createReservation' && this.pck === 'daily'
            let editReservationCase = this.typeCalendar === 'editReservation'
            let createBooking = this.typeCalendar === 'createBooking'
            let editBooking = this.typeCalendar === 'editBooking'
            let caregiverLeave = this.typeCalendar === 'caregiverLeave'
            let cancelNowPartial = this.typeCalendar === 'cancelNowPartial'
            if (createReservationCase || editReservationCase || createBooking || editBooking || caregiverLeave || cancelNowPartial) return (event.start._i !== this.calEvent.start._i) && (event.end._i !== this.calEvent.end._i)
            else return false
          })
        } else {
          this[this.calendarEvents] = this[this.calendarEvents].filter((event) => {
            return Moment(event.start._i, 'YYYY-MM-DD').startOf('date').isBefore(Moment(this.calEvent.start._i, 'YYYY-MM-DD').startOf('date'))
          })
          this.$emit('select', moment(this.calEvent.start._i).format('YYYY-MM-DD'))
        }
        if (this.typeCalendar === 'caregiverLeave' || this.typeCalendar === 'cancelNowPartial') {
          this.$emit('select', moment(this.calEvent.start._i).format('YYYY-MM-DD'))
        }
      }
      this.control.showRemoveSelectedDateDialog = false
    },
    eventClick (calendarEvents, injectVue) {
      return async function (calEvent, jsEvent, view) {
        const _this = injectVue
        try {
          let now = Moment(Moment(), 'YYYY-MM-DD').startOf('date')
          let date = Moment(calEvent.start._d, 'YYYY-MM-DD').startOf('date')
          let isPast = date.diff(now, 'days') < 0
          if (!isPast) {
            _this.control.showRemoveSelectedDateDialog = true
            _this.calEvent = calEvent
            _this.calendarEvents = calendarEvents
          } else {
            await _this.$alert('ไม่สามารถลบวันที่เลือกได้', '', {
              confirmButtonText: 'โอเค',
              type: 'error',
            })
          }
        } finally {}
      }
    },
    generatedDatesArray (eventsCalendarArray) {
      return eventsCalendarArray
        .map((event) => {
          return moment.range(event.start, moment(event.end).subtract(1, 'days'))
        })
        .reduce((datesArray, range) => {
          const date = Array.from(range.by('days')).map((d) => moment(d).format('YYYY-MM-DD'))
          return [
            ...datesArray,
            ...date,
          ]
        }, [])
    },
    backgroundColorHandler () {
      if (this.allowDates) {
        let ev = this.eventsCalendar.map((event) => {
          return moment(event.start._i).format('YYYY-MM-DD')
        })
        let allDate = document.querySelectorAll(`.fc-day-top .fc-day-number`)
        if (allDate.length > 0) {
          for (let i = 0; i < allDate.length; i++) {
            allDate[i].style.cssText = 'color: #D5D6DB !important;'
          }
        }
        allDate = document.querySelectorAll('.fc-day.fc-widget-content')
        if (allDate.length > 0) {
          for (let i = 0; i < allDate.length; i++) {
            allDate[i].style.setProperty('background-color', '#F1F3F6', 'important')
          }
        }
        this.allowDates.forEach(day => {
          let now = Moment(Moment(), 'YYYY-MM-DD').startOf('date')
          let date = Moment(day, 'YYYY-MM-DD').startOf('date')
          let isPast = date.diff(now, 'days') < 0
          if (!isPast) {
            let getDate = document.querySelectorAll(`.fc-day[data-date='${day}']`)
            let getDateNumber = document.querySelectorAll(`.fc-day-top[data-date='${day}'] .fc-day-number`)
            if (getDate.length > 0) {
              for (let i = 0; i < getDate.length; i++) {
                getDate[i].style.setProperty('background-color', '#FFFFFF', 'important')
                getDateNumber[i].style.setProperty('color', '#606266', 'important')
                if ((this.typeCalendar === 'cancelNowTotal' || this.typeCalendar === 'caregiverLeave' || this.typeCalendar === 'cancelNowPartial') && ev.indexOf(day) === -1) {
                  getDate[i].style.setProperty('background-color', '#FF577F', 'important')
                  getDate[i].style.setProperty('opacity', '0.15', 'important')
                }
              }
            }
          }
        })
      }
      this.setBackgroundWithPck()
    },
    setBackgroundWithPck () {
      setTimeout(() => {
        document.querySelectorAll('.fc-day-top.fc-today').forEach((day) => { day.style.setProperty('background-color', 'transparent', 'important') })
        document.querySelectorAll('.fc-day-top:not(.fc-past):not(.fc-disabled-day)').forEach((day) => { day.style.setProperty('color', '#606266', 'important') })
        switch (this.typeCalendar === 'editReservation' ? 'daily' : this.pck) {
          case 'daily':
            document.querySelectorAll('.fc-day.fc-widget-content.fc-sun:not(.fc-past):not(.fc-disabled-day)').forEach((day) => { day.style.setProperty('background-color', '#FFFFFF') })
            document.querySelectorAll('.fc-day-top.fc-sun:not(.fc-past):not(.fc-disabled-day)').forEach((day) => { day.style.setProperty('color', '#606266', 'important') })
            break
          case 'monthly':
            for (let i = 0; i < this.tranformDaysOff.length; i++) {
              let bgcl = `.fc-day.fc-widget-content.fc-${this.tranformDaysOff[i]}:not(.fc-past):not(.fc-disabled-day)`
              let cl = `.fc-day-top.fc-${this.tranformDaysOff[i]}:not(.fc-past):not(.fc-disabled-day)`
              document.querySelectorAll(bgcl).forEach((day) => { day.style.setProperty('background-color', '#F1F3F6', 'important') })
              document.querySelectorAll(cl).forEach((day) => { day.style.setProperty('color', '#D5D6DB', 'important') })
            }
            break
          case 'monthlyWithAddon':
            document.querySelectorAll('.fc-day.fc-widget-content.fc-sun:not(.fc-past):not(.fc-disabled-day)').forEach((day) => { day.style.setProperty('background-color', '#FFFFFF') })
            document.querySelectorAll('.fc-day-top.fc-sun:not(.fc-past):not(.fc-disabled-day)').forEach((day) => { day.style.setProperty('color', '#606266', 'important') })
            break
        }
      }, 0)
    },
  },
}
</script>
